import { Link } from "react-router-dom";
import type { Streamer } from "@/types/content";

interface HotStreamersProps {
  streamers: Streamer[];
}

export default function HotStreamers({ streamers }: HotStreamersProps) {
  return (
    <div className="flex flex-col gap-3">
      {streamers.map((s, i) => (
        <Link
          key={s.id}
          to={`/detail/${s.id}`}
          className="group flex items-center gap-3 p-2 rounded-lg hover:bg-background-100 transition-colors"
        >
          <span
            className={`w-6 h-6 shrink-0 flex items-center justify-center rounded-md text-xs font-bold font-heading ${
              i < 3 ? "bg-accent-500 text-background-50" : "bg-background-200 text-foreground-600"
            }`}
          >
            {i + 1}
          </span>
          <span className="w-11 h-11 shrink-0 rounded-full overflow-hidden bg-background-100">
            <img src={s.avatar} alt={s.name} title={`${s.name} 韩国女主播`} className="w-full h-full object-cover object-top" />
          </span>
          <span className="flex flex-col min-w-0 flex-1">
            <span className="text-sm font-medium text-foreground-900 group-hover:text-accent-600 transition-colors truncate">
              {s.name}
            </span>
            <span className="text-xs text-foreground-500 truncate">{s.program}</span>
          </span>
          <span className="text-xs text-accent-600 font-medium whitespace-nowrap">
            <i className="ri-fire-fill mr-0.5"></i>
            {s.heat}
          </span>
        </Link>
      ))}
    </div>
  );
}